import type { Address, } from "./Address";
import type { ValidChainId, } from "@bracket/types";
import type { TokenSymbol, } from "./TokenSymbol";

/**
 * @param {boolean} escrow this token can be used in escrow (for the relevent chain)
 * @param {boolean} bridge this token can act as a bridging token between ETH/WETH and BRKTETH.
 */
export declare type TokenDefinition<S extends string = string, L extends string = string, C extends ValidChainId = 1> = {
	/** the chain id of the token */
	chainId: C;

	/** the address of the token */
	address: Address;

	/** mainnet address for token vs ETH EXCEPT for ETH which is for USD. */
	priceFeedAddress?: Address;

	name: string;

	symbol: S;

	label: L;

	decimals: number;

	logo?: string;
	logoURI?: string;

	fees?: number | number[];

	/** when swapable is true, this token is a swapable SOURCE for the escrow application */
	swapable?: true;

	/** when swapto is true, this token is a swapable TARGET for the escrow application */
	swapto?: boolean;

	/** when stakable is true, this token is a stakable SOURCE for the escrow application */
	stakable?: true;

	/** when parity is true this token enjoys a 1:1 swap rate with ETH */
	parity: boolean;

	/** when flagged true, this token is considered inactive to the escrow application */
	inactive?: boolean;

	/** when flagged true, this token will be completely ignored - differs to inactive which normally greys the token out */
	disabled?: boolean;
	escrow?: boolean;
	bridge?: boolean;

	/** supported by "platform" */
	platform?: boolean;

	/** @bracket/platform accepts this token in supply */
	platform_supply?: boolean;

	/** the higher the number, the further to the bottom of a token list this item will sink. 1=top, 2=second, 99=secondlast, 1999=last */
	platform_weight?: number;

	/** when true, this token can be denominated in a bracket application */
	denominable?: boolean;

	/** when true, this token is a stablecoin */
	stablecoin?: boolean;

};

export const isTokenDefinition = ( value: unknown ): value is TokenDefinition => {
	if(typeof value === "object" && !Array.isArray(value) && value !== null) {
		return ["chainId", "address", "name", "symbol", "label", "decimals"].every(k => k in value);
	}
	return false;
}
